module.exports = __webpack_public_path__ + "static/media/cover2.a08d3e7b.jpg";